import React from 'react';
import { useParams } from 'react-router-dom';
import CreatePerformanceReview from './CreatePerformanceReview';

const ViewPerformanceReview = () => {
  const { id } = useParams();

  return <CreatePerformanceReview viewMode={true} reviewId={id} />;
};

export default ViewPerformanceReview;

